import { SubmissionErrors } from 'final-form';
import i18next from 'i18next';
import { FC } from 'react';
import { Field, Form } from 'react-final-form';

import { routes } from '~src/routingConfig';
import { translateError } from '~src/services/translationServices';
import { validatorMinValue6, validatorRequired } from '~src/services/validators';
import LoginButton from '~src/shared/buttons/LoginButton';
import IconInput, { InputIconType } from '~src/shared/form/inputs/IconInput';
import { composeValidators } from '~src/shared/reactFinalForm/validators';
import { LoginUserCredentials } from '~src/store/session/interfaces';
import { FieldType } from '~src/types';

import { ErrorContainer, NeedPasswordLink, NeedPasswordWrapper, StyledLoginForm } from './loginForm.sc';

interface OwnProps {
  t: i18next.TFunction;
  loginLoading: boolean;

  onSubmit(values: LoginUserCredentials): Promise<SubmissionErrors | void>;
}

type Props = OwnProps;

const LoginForm: FC<Props> = props => {
  const renderField = ({ autoFocus, input, label, meta: { touched, error }, labelKey }: FieldType) => (
    <IconInput
      {...input}
      autoFocus={autoFocus}
      label={label}
      type={input.type as InputIconType /* this stinks */}
      error={touched ? error : null}
      labelKey={labelKey}
    />
  );

  const { t } = props;

  return (
    <Form onSubmit={props.onSubmit}>
      {({ handleSubmit, submitError }) => (
        <StyledLoginForm onSubmit={handleSubmit} noValidate>
          <Field
            autoFocus
            name="identifier"
            label={t('x.login.input.placeholder.email_or_identifier')}
            type="user"
            children={renderField}
            validate={composeValidators([validatorRequired])}
            labelKey="x.login.input.placeholder.email_or_identifier"
          />
          <Field
            name="password"
            label={t('x.login.input.placeholder.password')}
            type="password"
            children={renderField}
            validate={composeValidators([validatorRequired, validatorMinValue6])}
            labelKey="x.login.input.placeholder.password"
          />
          {submitError && <ErrorContainer>{translateError(t, submitError)}</ErrorContainer>}
          <LoginButton isLoading={props.loginLoading}>
            <span data-translation="x.login.button.login.text">{t('x.login.button.login.text')}</span>
          </LoginButton>
          <NeedPasswordWrapper>
            <NeedPasswordLink to={routes.forgot_password} data-translation="x.login.no_password_link.text">
              {t('x.login.no_password_link.text')}
            </NeedPasswordLink>
            <NeedPasswordLink
              to={routes.otp}
              data-translation="x.login.otp_link.text"
              dangerouslySetInnerHTML={{ __html: t('x.login.otp_link.text') }}
            />
          </NeedPasswordWrapper>
        </StyledLoginForm>
      )}
    </Form>
  );
};

export default LoginForm;
